module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-startseite-hintergrund-6ac1a8c543e55d8701e3fb75957f1a17.jpg";